import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	text: {
		id: 'schools.resources.share.text',
		defaultMessage:
			'Share the following link with your administrators to bring Calm Schools to your school community.',
		description: 'Calm Schools share link text',
	},
	cta: {
		id: 'schools.resources.share.cta',
		defaultMessage: 'Get started',
		description: 'Calm Schools share cta',
	},
	disclaimer: {
		id: 'schools.resources.share.disclaimer',
		defaultMessage:
			'Your use of these resources is subject to Calm’s Term of Service; data collection practices are described in our Privacy Policy.',
		description: 'Disclaimer for Calm Schools resources',
	},
});
